import { createContext, useContext } from 'react';
import type { TomChatSessionController } from '../hooks/useTomChatController';

export type TomAssistantSessionState = Pick<
	TomChatSessionController,
	| 'isBusy'
	| 'canStop'
	| 'streamConversationId'
	| 'activeAssistantMessageId'
	| 'retryingMessageId'
	| 'progressLabel'
	| 'messageOverlays'
>;

export type TomAssistantSessionActions = Pick<
	TomChatSessionController,
	| 'removeResolvedMessageOverlays'
	| 'clearConversationOverlays'
	| 'runStream'
	| 'stopResponse'
	| 'cancelResponseForSwitch'
>;

export const TomAssistantSessionContext =
	createContext<TomAssistantSessionState | null>(null);

export const TomAssistantSessionActionsContext =
	createContext<TomAssistantSessionActions | null>(null);

export const useTomAssistantSession = () => {
	const session = useContext(TomAssistantSessionContext);
	if (!session) {
		throw new Error(
			'useTomAssistantSession must be used within TomAssistantSessionHost.',
		);
	}

	return session;
};

export const useTomAssistantSessionActions = () => {
	const actions = useContext(TomAssistantSessionActionsContext);
	if (!actions) {
		throw new Error(
			'useTomAssistantSessionActions must be used within TomAssistantSessionHost.',
		);
	}

	return actions;
};
